import { render } from "./OrganizationEditComponent.vue?vue&type=template&id=006e7f7e"
import script from "./OrganizationEditComponent.vue?vue&type=script&lang=js"
export * from "./OrganizationEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__